import * as React from 'react';
import { Control, Controller } from 'react-hook-form';
import { Password, PasswordProps } from 'primereact/password';
import 'primereact/password/password.min.css';
import cn from 'classnames';

import { PasswordFieldFooter } from './footer';
import classes from './password-field.module.scss';

export type PasswordFieldProps = PasswordProps & {
  isRequired?: boolean;
  labelClassName?: string;
  rootClassName?: string;
  inputClassName?: string;
  fieldId: string;
  hint?: string;
  label: string;
  error?: string;
  name: string;
  control?: Control<any>;
};

const SimplePasswordField = ({ ...props }: PasswordFieldProps) => (
  <div className={cn(classes.root, props.rootClassName)}>
    <label
      htmlFor={props.fieldId}
      className={cn(classes.label, props.labelClassName)}
    >
      {props.label}
      {props.label && props.isRequired ? (
        <span className={classes.asterix}>*</span>
      ) : null}
    </label>
    <Password
      name={props.name}
      value={props.value}
      inputId={props.fieldId}
      maxLength={props.maxLength}
      placeholder={props.placeholder}
      autoComplete="new-password"
      toggleMask={props.toggleMask}
      autoFocus={props.autoFocus}
      disabled={props.disabled}
      header={
        props.header || (
          <div className={classes.header}>{props.placeholder}</div>
        )
      }
      footer={props.footer}
      inputClassName={cn(classes.field, props.inputClassName, {
        [classes.fieldError]: props.error,
      })}
      onInput={props.onInput}
      onChange={props.onChange}
      onBlur={props.onBlur}
    />
    <small className={props.error ? classes.error : classes.hint}>
      {props.error ? props.error : props.hint}
    </small>
  </div>
);

export const PasswordField = (props: PasswordFieldProps) =>
  !props.control ? (
    <SimplePasswordField {...props} />
  ) : (
    <Controller
      render={({ field: { value = '', ref, ...field } }) => (
        <SimplePasswordField value={value} {...props} {...field} />
      )}
      name={props.name}
      control={props.control}
    />
  );

PasswordField.defaultProps = {
  toggleMask: true,
  footer: PasswordFieldFooter,
};
